import translations from '~/i18n/locales/en.json';
window.translations = translations;
